module.exports = __webpack_public_path__ + "static/img/ldt3.faff3e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/ldt/ldt3.png
// module id = XSoX
// module chunks = 0